<template>
  <div class="tag-box">
    <slot name="statistics"></slot>
    <div class="search_wrapper">
      <div class="search_head">
        <span>查询条件</span>
        <i
          class="searchDomw"
          @click="isSearchContent = !isSearchContent"
          :class="
            isSearchContent == true ? 'el-icon-arrow-up' : 'el-icon-arrow-down'
          "
        ></i>
        <!-- <el-button
          style="float: right; padding: 3px 0; color: #000"
          type="text"
          @click="Reset"
        >
          <i class="el-icon-refresh"></i>
          刷新页面
        </el-button> -->
      </div>
      <div class="search_content" v-show="isSearchContent">
        <div class="search_inline">
          <slot></slot>
        </div>
        <!-- <div class="arrowDown">
          <i
            class="el-icon-arrow-down"
            style="color: #000"
            @click="isSearchContent = !isSearchContent"
          ></i>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "globalTag",
  data() {
    return {
      isSearchContent: true,
    }
  },
  inject: ["reload"], //注入
  methods: {
    // 页面刷新
    Reset() {
      this.reload()
    },
  },
}
</script>

<style lang="less" scoped>
.tag-box {
  border-radius: 16px;
  overflow: hidden;
  border: 1px solid #ddd;
  margin-bottom: 15px;
}
/deep/ .search_wrapper {
  display: flex;
  flex-direction: column;
  position: relative;
  box-shadow: 0 0 6px rgba(151, 151, 151, 0.16);
  overflow: hidden;
  border-radius: 4px;
  .search_head {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    font-size: 16px;
    color: #676767;
    border-color: rgb(217, 217, 217);
    padding: 10px 15px;
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;

    i {
      background-color: #3875ff;
      color: #fff;
      border-radius: 50%;
      padding: 2px;
    }
  }
  .search_content {
    padding: 15px 20px 0px 5px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    background-color: #f1f5ff;
  }
  .search_inline {
    width: 100%;
  }
  .arrowDown {
    width: 28px;
    height: 28px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    left: 50%;
    bottom: -14px;
    transform: translate(-50%, 0px);
    border-radius: 50%;
    z-index: 2;
    cursor: pointer;
  }
}
.searchDomw {
  cursor: pointer;
}
</style>
